import { render, staticRenderFns } from "./stocktake.vue?vue&type=template&id=4674c7c8&scoped=true"
import script from "./stocktake.vue?vue&type=script&lang=js"
export * from "./stocktake.vue?vue&type=script&lang=js"
import style0 from "./stocktake.vue?vue&type=style&index=0&id=4674c7c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4674c7c8",
  null
  
)

export default component.exports